<div class="popup-content container-icon" [ngClass]="isShow && 'container-icon-active'" [formGroup]="editForm">
    <h3>Thêm sản phẩm</h3>

    <div class="form-group">
        <label>Sản phẩm</label>
        <dropdown [list]="products" (result)="patchValue($event)" [title]="'Chọn Sản phẩm'" [field]="'shortName'">
        </dropdown>
    </div>
    <div class="form-group">
        <label>Tiêu đề</label>
        <input class="form-control" formControlName="title" placeholder="VD: Tại đây, Link, Xem ngay...">
    </div>
    <div class="group__btn">
        <button class="ant-btn ng-star-inserted ant-btn-default" (click)="close()">Đóng</button>
        <button class="ant-btn ng-star-inserted ant-btn-primary" (click)="save()">Thêm sản phẩm</button>
    </div>
</div>